export default "__VITE_ASSET__CZw6LDJL__"